import {
    GET_LEAD_ERASURE_RULES_REQUEST,
    GET_LEAD_ERASURE_RULES_SUCCESS,
    GET_LEAD_ERASURE_RULES_FAIL,
    ADD_LEAD_ERASURE_RULE_REQUEST,
    ADD_LEAD_ERASURE_RULE_SUCCESS,
    ADD_LEAD_ERASURE_RULE_FAIL,
    UPDATE_LEAD_ERASURE_RULE_REQUEST,
    UPDATE_LEAD_ERASURE_RULE_SUCCESS,
    UPDATE_LEAD_ERASURE_RULE_FAIL,
    DELETE_LEAD_ERASURE_RULE_REQUEST,
    DELETE_LEAD_ERASURE_RULE_SUCCESS,
    DELETE_LEAD_ERASURE_RULE_FAIL,
    TOGGLE_LEAD_ERASURE_RULE_REQUEST,
    TOGGLE_LEAD_ERASURE_RULE_SUCCESS,
    TOGGLE_LEAD_ERASURE_RULE_FAIL,
} from "../constant";

const initialState = {
    rules: [],
    loading: false,
};

const leadErasureReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_LEAD_ERASURE_RULES_REQUEST:
        case ADD_LEAD_ERASURE_RULE_REQUEST:
        case UPDATE_LEAD_ERASURE_RULE_REQUEST:
        case DELETE_LEAD_ERASURE_RULE_REQUEST:
        case TOGGLE_LEAD_ERASURE_RULE_REQUEST:
            return { ...state, loading: true };

        case GET_LEAD_ERASURE_RULES_SUCCESS:
            return { ...state, loading: false, rules: action.payload };

        case ADD_LEAD_ERASURE_RULE_SUCCESS:
        case UPDATE_LEAD_ERASURE_RULE_SUCCESS:
        case DELETE_LEAD_ERASURE_RULE_SUCCESS:
        case TOGGLE_LEAD_ERASURE_RULE_SUCCESS:
            return { ...state, loading: false };

        case GET_LEAD_ERASURE_RULES_FAIL:
        case ADD_LEAD_ERASURE_RULE_FAIL:
        case UPDATE_LEAD_ERASURE_RULE_FAIL:
        case DELETE_LEAD_ERASURE_RULE_FAIL:
        case TOGGLE_LEAD_ERASURE_RULE_FAIL:
            return { ...state, loading: false };

        default:
            return state;
    }
};

export default leadErasureReducer;
